import { UpdateCategoryForm } from '~/components/forms/CategoryForm';
import { CategoryBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppUpdateCategoryPageProps = {
  appId: string;
  categoryId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppUpdateCategoryPage: React.FC<IAppUpdateCategoryPageProps> = (
  props,
) => {
  const { appId, categoryId, nextUrl, cancelUrl } = props;
  const navigate = useNavigate();

  const previousUrl = `/apps/${appId}/categories/${categoryId}`;

  return (
    <>
      <CategoryBreadcrumbs appId={appId} categoryId={categoryId} />

      <UpdateCategoryForm
        appId={appId}
        categoryId={categoryId}
        onSuccess={() =>
          // TODO: once the API is ready, navigate to the parent category if
          // the category was moved.
          navigate(nextUrl ?? previousUrl)
        }
        cancelUrl={cancelUrl ?? previousUrl}
      />
    </>
  );
};
